import { SORT_ASC } from '@/state/types/query'

export default {
  sort: 'title',
  order: SORT_ASC,
  page: 1,
  perPage: 10,
  filter: {},
}



// WEBPACK FOOTER //
// ./state/static/products.js